import Card from '@mui/material/Card';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { FC, PropsWithChildren, useEffect, useState } from 'react';

export const Metadata: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [isBodyScrollable, setIsBodyScrollable] = useState(false);

  const checkScrollbar = () => {
    const hasVerticalScrollbar = document.documentElement.scrollHeight > window.innerHeight;
    setIsBodyScrollable(hasVerticalScrollbar);
  };

  useEffect(() => {
    checkScrollbar();

    window.addEventListener('resize', checkScrollbar);

    return () => {
      window.removeEventListener('resize', checkScrollbar);
    };
  }, []);

  return (
    <>
      <Drawer
        variant="permanent"
        anchor="right"
        sx={{
          flexShrink: 1,
          minWidth: '250px',
          maxWidth: '400px',
          display: { xs: 'none', md: 'flex' },
        }}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: '#F3F3F3',
              position: 'relative',
              minWidth: '250px',
              maxWidth: 'min(100%, 400px)',
              ...(isBodyScrollable
                ? {
                    // Body scrolls - drawer grows with content
                    height: 'auto',
                    minHeight: '100vh',
                    overflowY: 'visible',
                  }
                : {
                    // Body doesn't scroll - drawer has fixed height and scrolls
                    height: 'calc(100vh - 128px)',
                    overflowY: 'auto',
                  }),
              overflowX: 'hidden',
            },
          },
        }}
        open
      >
        <List>{children}</List>
      </Drawer>
      <Card
        variant="outlined"
        sx={{ margin: '16px', padding: '16px', flex: 1, display: { xs: 'flex', md: 'none' } }}
      >
        <List sx={{ width: '100%' }}>{children}</List>
      </Card>
    </>
  );
};
